(function () {
  'use strict';

  angular
    .module('eclipseApp.linkAccount')
    .controller('alreadyConnectedController', AlreadyConnectedController);

  AlreadyConnectedController.$inject = ['$modalInstance', 'modalConfig', 'commonService'];

  function AlreadyConnectedController($modalInstance, modalConfig, commonService) {
    var ctrl = this;
    init();

    function init() {
      ctrl.emailAddress = modalConfig.emailAddress;
      ctrl.showContactButton = false;

      setTimeout(function() {
        angular.element('.btn_close').focus();
      });
    }

    function showModalBackDrop () {
      // to show the back drop when open up modal
      setTimeout(function () {
        document.body.classList.add('modal-open');
      }, 1000);
    }

    ctrl.goToSignin = function () {
      commonService.logOutUser(false, '', 'signin', false);
      showModalBackDrop();
    };

    ctrl.setBackDrop = function () {
      ctrl.cancel();
      showModalBackDrop();
    };

    ctrl.showContactSection = function () {
      ctrl.showContactButton = !ctrl.showContactButton;
    };

    ctrl.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }
})();
